module.exports = __webpack_public_path__ + "img/morningPaper.7f4ad6e3.png";